// src/components/corkboard/CorkStrings.jsx
//
// The red thread between pinned cards — one line per relationship whose two
// ends are both cards on this board.
//
// An SVG layer sitting under the cards rather than lines drawn per card,
// because a string belongs to neither of the cards it joins: drawing it from
// one of them would make it disappear when that card was dimmed, and make its
// z-order depend on which end was rendered first.
//
// `pointerEvents: none` on the layer is what keeps the strings out of the way
// of the drag — without it the SVG would swallow pointerdown anywhere a line
// crossed the gap between two cards. The <title> on each line still shows the
// relationship label on hover, because titles do not need pointer events.
import React from 'react';

import { STRING_COLOR } from './corkTokens';

export default function CorkStrings({ strings, width, height, hasSelection }) {
  return (
    <svg
      aria-hidden="true"
      width={width}
      height={height}
      style={{
        position: 'absolute', inset: 0, width: '100%', height: '100%',
        pointerEvents: 'none', zIndex: 1,
      }}
    >
      {strings.map((s) => {
        // Dimming is the same rule the cards use: with something selected, the
        // strings that do not touch it fade back. With nothing selected — or
        // with "show all connections" on, which is what clears the selection
        // ref the page passes in — every string is at full strength.
        const faded = hasSelection && !s.involved;
        return (
          <line
            key={s.id}
            x1={s.a.x} y1={s.a.y} x2={s.b.x} y2={s.b.y}
            stroke={STRING_COLOR}
            strokeWidth={s.involved ? 3 : 2}
            strokeLinecap="round"
            opacity={faded ? 0.12 : 0.75}
            style={{ filter: 'drop-shadow(0 1px 1px rgba(0,0,0,0.3))' }}
          >
            {s.label ? <title>{s.label}</title> : null}
          </line>
        );
      })}
    </svg>
  );
}
